module.exports = __webpack_public_path__ + "static/media/ico-big_bag.3d2216c2.svg";